import { render } from "./BookViewer.vue?vue&type=template&id=607eda18"
import script from "./BookViewer.vue?vue&type=script&lang=js"
export * from "./BookViewer.vue?vue&type=script&lang=js"

import exportComponent from "/home/eigyo65user/mystep/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__